import { IDataGridColumnConfiguration, IDataGridValidator } from '@trackman/baseball-shared-components';
import { PositionDict } from 'constants/PositionDictionary';
import { DataKey } from 'enums/DataKey';
import { IError } from 'interfaces/review/IReviewDataRow';
import { ReviewDataRow } from 'models/review/ReviewDataRow/ReviewDataRow';
import { isNotDuplicated, isNotSamePosition, playerHasNoEmptyGuid } from '../playerValidationHelpers';
import { getPlayerFromColumn } from './ValidationHelpers';

export const playerValidator: IDataGridValidator = {
  validate: (rows: ReviewDataRow[], columns: IDataGridColumnConfiguration[]) => {
    const columnObj = {} as { [key in DataKey]: IDataGridColumnConfiguration };

    for (const column of columns) {
      columnObj[column.dataKey as DataKey] = column;
    }

    const { pitcher, batter, catcher, firstBaseman, secondBaseman, thirdBaseman, shortStopper, leftFielder, centerFielder, rightFielder } =
      columnObj;

    if (
      !pitcher ||
      !batter ||
      !catcher ||
      !firstBaseman ||
      !secondBaseman ||
      !thirdBaseman ||
      !shortStopper ||
      !leftFielder ||
      !centerFielder ||
      !rightFielder
    ) {
      return rows.map(() => []);
    }

    return rows.map((r) =>
      validateRow(
        r,
        pitcher,
        batter,
        catcher,
        firstBaseman,
        secondBaseman,
        thirdBaseman,
        shortStopper,
        leftFielder,
        centerFielder,
        rightFielder
      )
    );
  },
};

const validateRow = (
  row: ReviewDataRow,
  pitcherColumn: IDataGridColumnConfiguration,
  batterColumn: IDataGridColumnConfiguration,
  catcherColumn: IDataGridColumnConfiguration,
  firstBasemanColumn: IDataGridColumnConfiguration,
  secondBasemanColumn: IDataGridColumnConfiguration,
  thirdBasemanColumn: IDataGridColumnConfiguration,
  shortStopperColumn: IDataGridColumnConfiguration,
  leftFielderColumn: IDataGridColumnConfiguration,
  centerFielderColumn: IDataGridColumnConfiguration,
  rightFielderColumn: IDataGridColumnConfiguration
): IError[] => {
  const errors: IError[] = [];
  if (row.isWarmup || row.isDeleted) {
    return [];
  }
  const pitcher = getPlayerFromColumn(row, pitcherColumn);
  const batter = getPlayerFromColumn(row, batterColumn);
  const catcher = getPlayerFromColumn(row, catcherColumn);
  const firstBaseman = getPlayerFromColumn(row, firstBasemanColumn);
  const secondBaseman = getPlayerFromColumn(row, secondBasemanColumn);
  const thirdBaseman = getPlayerFromColumn(row, thirdBasemanColumn);
  const shortStopper = getPlayerFromColumn(row, shortStopperColumn);
  const leftFielder = getPlayerFromColumn(row, leftFielderColumn);
  const centerFielder = getPlayerFromColumn(row, centerFielderColumn);
  const rightFielder = getPlayerFromColumn(row, rightFielderColumn);

  const defensivePositions = [
    pitcher,
    batter,
    catcher,
    firstBaseman,
    secondBaseman,
    thirdBaseman,
    shortStopper,
    leftFielder,
    centerFielder,
    rightFielder,
  ];

  defensivePositions.forEach((firstPlayer) => {
    if (!firstPlayer.id) {
      return;
    }

    defensivePositions.forEach((secondPlayer) => {
      if (!secondPlayer.id) {
        return;
      }

      const fpPosition = PositionDict[firstPlayer.defaultPosition];
      const spPosition = PositionDict[secondPlayer.defaultPosition];

      if (
        isNotSamePosition(firstPlayer, secondPlayer) &&
        isNotDuplicated(fpPosition, spPosition, errors) &&
        playerHasNoEmptyGuid(firstPlayer, secondPlayer)
      ) {
        errors.push({
          dataKey: `${fpPosition}-${spPosition}`,
          errorMessage: `${fpPosition} is same as ${spPosition}`,
        });
      }
    });
  });

  return errors;
};
